import { ErrorToast } from "../components/toastify";
import { AxiosGetMethod } from "../helpers/customAxios";
import HandleLogout from "./handleLogout";

const getEventCreds = async (eventId) => {
  const credRes = await AxiosGetMethod(
    `org/view-event-creds?event_id=${eventId}`
  );
  if (credRes.status === 200) {
    return credRes.data.data;
  } else {
    if (credRes?.status === 401) HandleLogout();
    ErrorToast("Can't find credentials");
    return null;
  }
};

export default getEventCreds;
